<template>
  <v-autocomplete
    v-model="projectValue"
    :attach="true"
    :clearable="clearable"
    :dense="dense"
    :disabled="disabled"
    :items="projects"
    item-text="name"
    :item-value="itemValue"
    :loading="isLoading"
    :multiple="multiple"
    :outlined="outlined"
    :label="$tc('Espace evenementiel')"
    :return-object="returnObject"
    :search-input="search"
    @input="handleInput"
  ></v-autocomplete>
</template>

<script>
import _ from "lodash"
import { ProjectService } from "@/services"

export default {
  props: {
    outlined: {
      type: Boolean,
      default: true
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    itemValue: {
      type: String,
      default: "pk"
    },
    dense: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    }
  },
  data() {
    return {
      search: "",
      isLoading: false,
      projectValue: null,
      projects: []
    }
  },
  created() {
    // Do Nothing if not authentified
    if (!this.$store.getters["app/isSignedIn"]) return

    this.getProjects()
    if (this.value) this.projectValue = _.cloneDeep(this.value)
  },
  watch: {
    value: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) this.projectValue = _.cloneDeep(newValue)
      }
    }
  },
  methods: {
    getProjects() {
      this.isLoading = true
      let companyId = this.$store.getters["app/getCompany"].pk
      ProjectService.get(this, companyId)
        .then(r => {
          this.projects = r.results
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleInput(newValue) {
      if (newValue) {
        this.$emit("input", newValue)

        // redirect to main project view on change
        const redirect = "Project"
        if (this.$route.name != redirect) {
          this.$router.push({ name: redirect })
        }
      }
    }
  }
}
</script>
